<template>
  <footer class="site-footer">
    <div class="container">
      <p class="footer-desc" v-html="this.messages[this.lang].colophon"></p>
      <nav class="footer-nav">
        <a :href="'/contact.html#/' + this.lang">{{ this.messages[this.lang].contact }}</a>
      </nav>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'SiteFooter',
    data() {
      return {
        lang: 'zh',
        messages: {
          en: {
            colophon: '',
            contact: 'Contact Us',
          },
          zh: {
            colophon: '<span>小米科技</span> <span>京ICP备10046444号</span> <span>京公网安备11010802020134号</span>',
            contact: '联系我们',
          },
        },
      };
    },
    created() {
      if (location.href.indexOf('/en') !== -1) {
        this.lang = 'en';
      } else {
        this.lang = 'zh';
      }
    },
  };
</script>



// WEBPACK FOOTER //
// SiteFooter.vue?78273a85